<template>
    <div>
        <ul class="search-pagination">
            <li title="First"><button v-html="'&lt;&lt;'" @click="first" :disabled="selectedPage <= 1" /></li>
            <li title="Previous"><button v-html="'&lt;'" @click="previous" :disabled="selectedPage <= 1" /></li>
            <li><select v-model="selectedPage" @change="$emit('page', selectedPage)">
                <option
                    v-for="i in pagination.TotalPages || 1"
                    v-text="i"
                    :selected="i === pagination.CurrentPage"
                />
            </select></li>
            <li title="Next"><button v-html="'&gt;'" @click="next" :disabled="selectedPage >= pagination.TotalPages" /></li>
            <li title="Last"><button v-html="'&gt;&gt;'" @click="last" :disabled="selectedPage >= pagination.TotalPages" /></li>
        </ul>
        <div class="pagination" v-text="paginationText" v-if="!pagination.hasOwnProperty('TotalRows') || pagination.TotalRows" />
        <div class="suppressions" v-text="suppressionText" v-if="suppressionText" />
    </div>
</template>

<script>

export default {
    props: {
        pagination: {
            type: Object,
            required: true,
        },
    },
    data: function() {
        return {
            selectedPage: 1,
        }
    },
    watch: {
        pagination: {
            deep: true,
            handler() {
                this.selectedPage = this.pagination.CurrentPage;
            },
        },
    },
    computed: {
        paginationText() {
            if (!this.pagination.hasOwnProperty('TotalRows')) {
                return 'Loading results 1-10 of TBD';
            }
            const start = (this.pagination.CurrentPage - 1) * this.pagination.PageSize + 1;
            const end = Math.min(this.pagination.TotalRows, start + Math.min(this.pagination.PageSize, this.pagination.TotalRows) - 1);
            return 'Showing results ' + start.toLocaleString() + '-' + end.toLocaleString()
                + ' of ' + this.pagination.TotalRows.toLocaleString();
        },
        suppressionText() {
            if (!this.pagination.Suppressions) {
                return null;
            }
            return '(' + this.pagination.Suppressions
                + ' result' + (this.pagination.Suppressions > 1 ? 's were' : ' was')
                + ' hidden in this search)'
            ;
        },
    },
    methods: {
        first() {
            this.selectedPage = 1;
            this.$emit('page', this.selectedPage);
        },
        previous() {
            this.selectedPage = Math.max(1, Number(this.selectedPage) - 1);
            this.$emit('page', this.selectedPage);
        },
        next() {
            this.selectedPage = Math.min(Number(this.selectedPage) + 1, Number(this.pagination.TotalPages));
            this.$emit('page', this.selectedPage);
        },
        last() {
            this.selectedPage = Number(this.pagination.TotalPages);
            this.$emit('page', this.selectedPage);
        },
    },
}
</script>

<style lang="scss">
.search-pagination {
    display: flex;
    list-style-type: none !important;
    column-gap: 10px;
    justify-content: center;
    padding: 0;

    li {
        margin: 0 !important;
    }

    * {
        font-size: 14pt;
    }

    button, select {
        padding: 10px;
    }

    select {
        text-align: right;
    }

    option {
        text-align: right;
    }
}
.pagination, .suppressions {
    text-transform: uppercase;
    font-weight: normal;
    font-size: 10pt;
    color: #3cacde;
    text-align: center;
}
</style>
